module.exports = __webpack_public_path__ + "static/media/WA.59f365e0.png";